import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActionSheetController, AlertController } from '@ionic/angular';
import { ConsultaService } from '../../services/consulta.service';
import { Map, latLng, tileLayer, Layer, marker, icon, popup } from 'leaflet';
import { Router } from '@angular/router';
import { Instalacion } from '../../models/instalacion';
import { modalidadDe } from '../../models/modalidad-instalacion';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';


@Component({
    selector: 'app-principal',
    templateUrl: './principal.page.html',
    styleUrls: ['./principal.page.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PrincipalPage implements OnInit {

    public inicio: boolean;
    public map: Map;
    public marker: marker;
    public instalaciones: any = [];
    public tarifas: any = [];
    public title: string;
    public opciones: any = [];
    public tar: any[] = [];

    constructor(
        public _consulta: ConsultaService,
        public alertController: AlertController,
        public _router: Router,
        private actionSheet: ActionSheetController,
        private _translate: TranslateService,
        private storage: Storage,
    ) {
        this.inicio = false;
    }

    ngOnInit() {

    }
    ionViewWillEnter() {
        this.getInstalaciones();
        this._consulta.compruebaLogin(true);
        this.storage.get('last_buy').then(last => {
            if (last != null) {
                const cons = '{"id": "' + last + '"}';
                this._consulta.isPayed(cons).subscribe(result => {
                    if (result == 1) {
                        this.alertError2('¡Éxito!', 'Has realizado la reserva correctamente.', 1);
                    } else {
                        this.alertError2('Error en el pago', 'Ha habido un problema con el pago. Revisa tus reservas.', 0);
                    }
                });
                this.storage.set('last_buy', null);
            }
        });
        /* this.storage.get('esRetorno').then(esRetorno => {
            if (esRetorno == 1) {
                this.alertError('¡Éxito!', 'Tu reserva se ha realizado correctamente.');
                this.storage.set('esRetorno', 0);
            }
        }); */
    }

    changeInicio(value) {
        this.inicio = value;
    }

    getInstalaciones() {

        this._consulta.getInstalaciones().subscribe(
            result => {
                this.instalaciones = result;
                for (let i = 0; i < this.instalaciones.length; i++) {
                    this.instalaciones[i].showTarifaInstalacion = false;
                };

            },
            error => {
                ///
            });
    }

    goReservas(instalacion: Instalacion) {
        const modalidad = modalidadDe(instalacion);
        if (!modalidad) {
            return;
        }
        this._router.navigateByUrl(modalidad.ruta, { state: { instalacion: instalacion } });
    }

    unidadPrecio(instalacion: Instalacion): string {
        const modalidad = modalidadDe(instalacion);
        return modalidad ? modalidad.unidadPrecio : '';
    }

    goAyuda() {
        this._router.navigate(['/ayuda']);
    }

    getTarifas(instalacion: Instalacion, index): any {
        const cons = '{"id": "' + this._consulta.usuario.Id + '","id_instalacion":"' + instalacion.id + '" ,"language": "ES"}';
        this._consulta.getOpciones(cons).subscribe(
            result => {
                this.tar = result['Total'];
                if (this.instalaciones[index].showTarifaInstalacion) {
                    this.instalaciones[index].showTarifaInstalacion = false;
                } else {
                    this.instalaciones[index].showTarifaInstalacion = true;
                }
                
                for (let i = 0; i < this.instalaciones.length; i++) {
                    
                    if (this.instalaciones[i] !== this.instalaciones[index]) {
                        this.instalaciones[i].showTarifaInstalacion = false;
                    }
                }
            },
            error => {
                console.error("Error al obtener las tarifas:", error);
            }
        );
    }

    showTarifa(instalacion: Instalacion) {
        let text = '';
        const cons = '{"id": "' + this._consulta.usuario.Id + '","id_instalacion":"' + instalacion.id + '" ,"language": "ES"}';
        this._consulta.getOpciones(cons).subscribe(
            result => {
                this.opciones = result['Total'];
                if (instalacion.tipo_reserva === 'H') {
                    text = 'Precio por hora ' + this.opciones[0].importe + ' €' + '/ hora';
                } else {
                    text = 'Precio por día ';
                    for (let i = 0; i < this.opciones.length; i++) {
                        text = text + '<p>' + this.opciones[i].nombre + ' ' + this.opciones[i].importe + ' €' + '/ día';
                    }
                }
                this.alertTarifas(text, instalacion);
            });

    }

    async alertTarifas(text, instalacion: Instalacion) {
        const alert = await this.alertController.create({
            header: 'Tarifas',
            message: text,
            buttons: [{ text: 'OK' }, {
                text: 'Reservar', handler: () => {
                    this.goReservas(instalacion);
                }
            }]
        });
        await alert.present();
    }

    async alertError(hdr: string, msg: string) {
        const alert = await this.alertController.create({
            header: hdr,
            message: msg,
            buttons: [{
                text: 'OK'
            }]
        });
        await alert.present();
    }

    async alertError2(hdr: string, msg: string, ok: number) {
        const alert = await this.alertController.create({
            header: hdr,
            message: msg,
            backdropDismiss: false,
            buttons: [{
                text: 'OK',
                handler: () => {
                    if (ok == 1) {
                        this._router.navigate(['/mis-reservas']);
                    }
                }
            }]
        });
        await alert.present();
    }
}
